import React, {useEffect, useState} from 'react';
import styles from './VaccineRegistration.module.css';
import axios from "axios";
import {getHostIP, getSiteTypeFromHostname} from "../../networking/Hosts";
import FluRegistration from './FluRegistration';
import RsvRegistration from './RsvRegistration';

const LegacyVaccineRegistration = () => {
    const hostIP = getHostIP();


    const schools = [
        {
            id: 'shandong-normal',
            name: '山东师范大学',
            clinics: [
                {
                    name: '公共管理学院',
                    majors: ["公共管理类", "劳动与社会保障", "其他"]
                },
                {
                    name: '其他',
                    majors: ['其他']
                }
            ]
        },
        {
            id: 'shandong-art',
            name: '山东工艺美术学院',
            clinics: [
                {
                    name: '工业设计学院',
                    majors: ["工业设计(理)", "产品设计(工业)", "艺术与科技", "其他"]
                },
                {
                    name: '其他',
                    majors: ['其他']
                }
            ]
        },
        {
            id: 'shandong-sunhand',
            name: '山东圣翰财贸职业学院',
            clinics: [
                {
                    name: '艺术学院',
                    majors: ["幼儿教育", "早期教育", "体育舞蹈", "运动训练", "其他"]
                },
                {
                    name: '信息工程学院',
                    majors: ["软件技术", "物联网应用技术", "大数据技术", "计算机应用技术", "其他"]
                },
                {
                    name: '其他',
                    majors: ['其他']
                }
            ]
        },
        {
            id: 'shandong-women',
            name: '山东女子学院',
            clinics: [
                {
                    name: '经济学院',
                    majors: ["金融工程(本)", "国际经济与贸易(本)", "国际经济与贸易(专升本)", "金融学(本)", "其他"]
                },
                {
                    name: '其他',
                    majors: ['其他']
                }
            ]
        },
        {
            id: 'shandong-labor',
            name: '山东劳动职业技术学院',
            clinics: [
                {
                    name: '智能制造系',
                    majors: ["数控技术", "机械设计与制造", "机械制造及自动化", "其他"]
                },
                {
                    name: '劳动经济系',
                    majors: ["会计", "人力资源", "其他"]
                },
                {
                    name: '其他',
                    majors: ['其他']
                }
            ]
        }
    ];

    const [isParent, setIsParent] = useState(false);
    const [name, setName] = useState('');
    const [studentId, setStudentId] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [vaccineType, setVaccineType] = useState('');
    const [selectedSchool, setSelectedSchool] = useState('');
    const [selectedAcademy, setSelectedAcademy] = useState('');
    const [selectedMajor, setSelectedMajor] = useState('');
    const [appointmentDate, setAppointmentDate] = useState('');
    const academies = selectedSchool ? schools.find(area => area.id === selectedSchool).clinics : [];
    const majors = selectedAcademy ? academies.find(academy => academy.name === selectedAcademy).majors : [];
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserInfo = async () => {
            let data = null;
            try {
                const response = await fetch(hostIP + '/api/obtainInfo', {
                    method: 'GET',
                    credentials: 'include' // 包含cookie
                });

                data = await response.json();
                setSelectedSchool(data.area_name || '');
                setSelectedAcademy(data.clinic_name || '');
                setSelectedMajor(data.major_name || '');

            } catch (err) {

                setSelectedSchool('');
                setSelectedAcademy('');
                setSelectedMajor('');

            }
        };

        fetchUserInfo();
    }, []); // 空依赖数组表示只在组件挂载时执行一次

    const validateForm = () => {
        const newErrors = {};
        if (!name) newErrors.name = '请输入姓名';
        if (!isParent && !studentId) newErrors.studentId = '请输入学号';
        if (!gender) newErrors.gender = '请选择性别';
        if (!selectedSchool) newErrors.school = '请选择学校';
        if (!selectedAcademy) newErrors.academy = '请选择学院';
        if (!vaccineType) newErrors.vaccineType = '请选择希望接种的价次';
        if (!selectedMajor) newErrors.major = '请选择专业';
        if (!phone) {
            newErrors.phone = '请输入手机号';
        } else if (phone.length !== 11) {
            newErrors.phone = '手机号必须是11位数字';
        }
        if (!appointmentDate) newErrors.date = '请选择接种日期'

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            // Here you would typically send the data to your backend
            const formData = {
                phone: phone,
                school_number: studentId,
                gender_male: gender === "male" ? 1 : 0,
                academy: selectedAcademy,
                school: selectedSchool,
                data_source: isParent,
                vaccine_type: vaccineType,
                name: name,
                date: appointmentDate,
                major: selectedMajor
            };
            axios.defaults.withCredentials = true;

            // Submit the form data to the server
            axios.post(hostIP + '/api/submitVaccineAppointment', formData).then(() => setSubmitted(true))
                .catch(error => console.error('提交表单时发生错误!', error));
        }
    };

    if (submitted) {
        return (<div className={styles.container}>
            <h3 className={styles.title}>感谢您的登记！</h3>
            <p className={styles.description}>
                同学您好，感谢登记接种HPV疫苗，接下来请通过微信“约苗”小程序自行预约，并参考预约指南：
            </p>
            <h4>【女性HPV疫苗预约指南】</h4>
            <p className={styles.description}>
                微信“约苗”小程序预约，长清区可预约接种点：
                1）山东中医药大学附属大学城医院
                可预约9价女性HPV疫苗，咨询电话87226468
                2）济南市长清区中医医院（东院区）预防接种门诊
                可预约2价、9价女性HPV疫苗，咨询电话87206227
                *山东师范大学的同学还可以前往校医院线下预约9价疫苗，咨询电话86181851
            </p>

            <h4>【男性HPV疫苗预约指南】</h4>
            <p className={styles.description}>
                微信“约苗”小程序预约：长清区暂无可预约接种点，请选择济南市其他接种点预约4价男性HPV疫苗。9价男性HPV疫苗4月15日刚获批，请先订阅，并留意后续预约开放通知。

                尽早接种HPV疫苗，为青春加一道守护线！如有其他问题，欢迎扫码加入我们的预约咨询群！
            </p>


            <img src="/chat.png" alt="" className={styles.chat_invite}/>
        </div>);
    }

    return (<div className={styles.container}>
        <h3 className={styles.title}>HPV疫苗接种预约登记</h3>
        <p className={styles.description}>
            {isParent ? '如果您愿意让孩子接种HPV疫苗，请留下孩子信息，大学城医院会为您预约并通知接种时间。' : '如果您愿意接种HPV疫苗，请留下信息，大学城医院会为您预约并通知接种时间。'}
        </p>

        <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
                <label className={styles.label}>您是学生还是家长？</label>
                <div className={styles.radioGroup}>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            name="userType"
                            checked={!isParent}
                            onChange={() => setIsParent(false)}
                        />
                        学生
                    </label>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            name="userType"
                            checked={isParent}
                            onChange={() => setIsParent(true)}
                        />
                        家长
                    </label>
                </div>
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>{isParent ? '孩子姓名' : '姓名'}</label>
                <input
                    type="text"
                    className={styles.input}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder={`请输入${isParent ? '孩子' : ''}姓名`}
                />
                {errors.name && <span className={styles.error}>{errors.name}</span>}
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>学号</label>
                <input
                    type="text"
                    className={styles.input}
                    value={studentId}
                    onChange={(e) => setStudentId(e.target.value)}
                    placeholder={`请输入${isParent ? '孩子' : ''}学号`}
                />
                {errors.studentId && <span className={styles.error}>{errors.studentId}</span>}
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>{isParent ? '孩子性别' : '性别'}</label>
                <div className={styles.radioGroup}>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            name="gender"
                            value="male"
                            checked={gender === 'male'}
                            onChange={() => setGender('male')}
                        />
                        男
                    </label>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            name="gender"
                            value="female"
                            checked={gender === 'female'}
                            onChange={() => setGender('female')}
                        />
                        女
                    </label>
                </div>
                {errors.gender && <span className={styles.error}>{errors.gender}</span>}
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>{isParent ? '孩子手机号码' : '手机号码'}</label>
                <input
                    type="tel"
                    className={styles.input}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="请输入手机号码"
                />
                {errors.phone && <span className={styles.error}>{errors.phone}</span>}
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>预约HPV疫苗类型</label>
                <select
                    className={styles.input}
                    value={vaccineType}
                    onChange={(e) => setVaccineType(e.target.value)}
                >
                    <option value="">请选择</option>
                    <option value="二价">二价</option>
                    <option value="四价">四价</option>
                    <option value="九价">九价</option>
                    <option value="都行">都行</option>
                </select>
                {errors.vaccineType && (
                    <span className={styles.error}>{errors.vaccineType}</span>
                )}
            </div>

            <div className={styles.formGroup}>
                <label className={styles.label}>预约接种日期</label>
                <input
                    type="date"
                    className={styles.input}
                    value={appointmentDate}
                    onChange={(e) => setAppointmentDate(e.target.value)}
                    min="2025-04-14"
                    max="2025-06-30"
                />
                {errors.date && (
                    <span className={styles.error}>{errors.date}</span>
                )}
            </div>


            <div className={styles.formDiv}>
                <label className={styles.label}>
                    {isParent ? "孩子的学校：" : "选择您的学校："}
                </label>
                <select
                    value={selectedSchool}
                    onChange={(e) => {
                        setSelectedSchool(e.target.value);
                        setSelectedAcademy(''); // Reset clinic selection when area changes
                        setSelectedMajor('');
                    }}
                    className={styles.select}
                >
                    <option value="">选择学校</option>
                    {schools.map(school => (
                        <option key={school.id} value={school.id}>
                            {school.name}
                        </option>
                    ))}
                </select>

                {errors.school && (
                    <span className={styles.error}>{errors.school}</span>
                )}
            </div>

            {selectedSchool && (
                <div className={styles.formDiv}>
                    <label className={styles.label}>
                        {isParent ? "孩子的学院：" : "选择您的学院："}
                    </label>
                    <select
                        value={selectedAcademy}
                        onChange={(e) => {
                            setSelectedAcademy(e.target.value);
                            setSelectedMajor('');
                            console.log(selectedAcademy);
                        }}
                        className={styles.select}
                    >
                        <option value="">选择学院...</option>
                        {academies.map((academy, index) => (
                            <option key={index} value={academy.name}>
                                {academy.name}
                            </option>
                        ))}
                    </select>

                    {errors.academy && (
                        <span className={styles.error}>{errors.academy}</span>
                    )}
                </div>
            )}

            {selectedAcademy && (
                <div className={styles.formDiv}>
                    <label className={styles.label}>
                        {isParent ? "孩子的专业：" : "选择您的专业："}
                    </label>

                    <select
                        value={selectedMajor}
                        onChange={(e) => setSelectedMajor(e.target.value)}
                        className={styles.select}
                    >
                        <option value="">选择专业...</option>
                        {majors.map((major, index) => (
                            <option key={index} value={major}>
                                {major}
                            </option>
                        ))}
                    </select>
                    {errors.major && (
                        <span className={styles.error}>{errors.major}</span>
                    )}
                </div>
            )}


            <button type="submit" className={styles.button}>
                提交预约申请
            </button>

            <p className={styles.disclaimer}>
                注：提交预约申请后，大学城医院会与您联系确认接种事宜。
                <br/>
                如有疑问，请咨询87226468！
            </p>
        </form>
    </div>);
};

const VaccineRegistration = () => (
    getSiteTypeFromHostname() === 'rsv' ? <RsvRegistration/> : getSiteTypeFromHostname() === 'vax' ? <FluRegistration/> : <LegacyVaccineRegistration/>
);

export default VaccineRegistration;
